import { apiFetch, safeFetch } from "./client";
import type { Matter, Workstream } from "../types";

export async function listMatters(): Promise<Matter[]> {
  const r = await safeFetch<{ matters: Matter[] }>("/matters");
  return r?.matters ?? [];
}

export async function getMatter(id: string): Promise<(Matter & { workstreams?: Workstream[] }) | null> {
  const r = await safeFetch<{ matter: Matter & { workstreams?: Workstream[] } }>(`/matters/${id}`);
  return r?.matter ?? null;
}

export async function createMatter(input: {
  name: string;
  client?: string;
  dealType?: string;
  status?: string;
}): Promise<Matter | null> {
  const r = await safeFetch<{ matter: Matter }>("/matters", {
    method: "POST",
    body: JSON.stringify(input),
  });
  return r?.matter ?? null;
}

export async function updateMatter(id: string, patch: Partial<Matter>): Promise<Matter | null> {
  const r = await safeFetch<{ matter: Matter }>(`/matters/${id}`, {
    method: "PUT",
    body: JSON.stringify(patch),
  });
  return r?.matter ?? null;
}

export async function deleteMatter(id: string): Promise<boolean> {
  try {
    await apiFetch(`/matters/${id}`, { method: "DELETE" });
    return true;
  } catch {
    return false;
  }
}
